var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-view',{attrs:{"styles":"flex"}},_vm._l((_vm.tag_list),function(item){return _c('tag-widget',_vm._b({key:item.id,attrs:{"id":item.id,"text":item.text},on:{"on_click":_vm.$_click},model:{value:(item.selected),callback:function ($$v) {_vm.$set(item, "selected", $$v)},expression:"item.selected"}},'tag-widget',_vm.tag_data,false))}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9b6e10a4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BTXUI/tags/tags-widget.vue
// module id = null
// module chunks = 